<script setup>
import { useForm } from '@inertiajs/vue3';

import Button from '@/Components/Button/Button.vue';
import Error from '@/Components/Input/Error.vue';
import StaffLayout from '@/Layouts/StaffLayout.vue';

// Icons
import { mapErrors } from '@/utilities';
import saveIcon from '@i/save-white.svg';
import { inject } from 'vue';

const route = inject('route');

const form = useForm({
    name: { nl: '', en: '' },
    order_column: '',
});

const sendForm = () => {
    form.post(route('staff.faq-categories.store'), {
        preserveState: true,
        onError: (errors) => (form.errors = mapErrors(errors)),
    });
};
</script>

<template>
    <StaffLayout :title="$t('Create FAQ')">
        <h1 class="mb-2 font-bold text-8">{{ $t('Create {model}', { model: $t('FAQ Category') }) }}</h1>
        <div class="grid gap-x-8 gap-y-2 md:grid-cols-2">
            <FormKit
                type="text"
                name="name_nl"
                :label="$t('Name') + ' (nl)'"
                v-model="form.name.nl"
                :errors="form.errors.name?.nl"
                :value="form.name.nl"
            />

            <FormKit
                type="text"
                name="category_en"
                :label="$t('Name') + ' (en)'"
                v-model="form.name.en"
                :errors="form.errors.name?.en"
                :value="form.name.en"
            />

            <FormKit
                type="number"
                name="order_column"
                :label="$t('Order Column')"
                v-model="form.order_column"
                :errors="form.errors.order_column"
                :value="form.order_column"
            />
        </div>
        <Error :error="form.errors.name" />
        <div class="flex justify-end">
            <Button
                orange
                type="button"
                :processing="form.processing"
                :recentlySuccessful="form.recentlySuccessful"
                :text="$t('Save')"
                :icon="saveIcon"
                @click="sendForm"
            />
        </div>
    </StaffLayout>
</template>
